import { Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { B2CLoginError, LeftArrowWhite, NewBlueDelete } from 'Images';

interface ICancelEditDialog {
  onClickSave: () => void;
  onClickGoBack: () => void;
}

export const CancelEditDialog = ({
  onClickSave,
  onClickGoBack,
}: ICancelEditDialog) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Reimbursements
  ).cancelEditDialog;

  const isDesktop = useIsDesktop();

  return (
    <Stack
      gap='24px'
      p={isDesktop ? '56px 130.5px' : '72px 40px 24px'}
      alignItems='center'
    >
      <Avatar
        alt=''
        src={B2CLoginError}
        sx={
          isDesktop
            ? { width: '152px', height: '103.83px' }
            : { width: '142px', height: '97px' }
        }
      />
      <Stack alignItems='center'>
        <Typography
          component='h1'
          variant='h6'
          fontWeight='600'
          fontSize='24px'
          lineHeight='31px'
        >
          {dictionary.title}
        </Typography>
      </Stack>
      <Stack
        direction='row'
        justifyContent='center'
        gap='24px'
        mt={isDesktop ? '64px' : '56px'}
      >
        <Button
          variant='outlined'
          sx={{
            bgcolor: 'white',
            width: '234px',
            alignItems: 'center',
            gap: '4px',
            p: isDesktop ? '12px 0px' : '8px 0px',
            height: isDesktop ? undefined : '36px',
          }}
          onClick={onClickGoBack}
        >
          <Avatar
            alt=''
            src={NewBlueDelete}
            sx={{ width: '20px', height: '20px' }}
          />
          <Typography variant='body4'>{dictionary.goBack}</Typography>
        </Button>
        <Button
          variant='contained'
          sx={{
            bgcolor: '#3A6EEC',
            width: '234px',
            alignItems: 'center',
            gap: '4px',
            p: isDesktop ? '12px 0px' : '8px 0px',
            height: isDesktop ? undefined : '36px',
          }}
          onClick={onClickSave}
        >
          <Typography variant='body4'>{dictionary.save}</Typography>
          <Avatar
            alt=''
            src={LeftArrowWhite}
            sx={{ width: '20px', height: '20px' }}
          />
        </Button>
      </Stack>
    </Stack>
  );
};
